import { render, staticRenderFns } from "./DonationPage.vue?vue&type=template&id=38af9c78&scoped=true&"
import script from "./DonationPage.vue?vue&type=script&lang=js&"
export * from "./DonationPage.vue?vue&type=script&lang=js&"
import style1 from "./DonationPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af9c78",
  null
  
)

export default component.exports